import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from '../locales/en/translation.json';
import zhCnTranslation from '../locales/zh-cn/translation.json';
import zhHkTranslation from '../locales/zh-hk/translation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      'zh-CN': {
        translation: zhCnTranslation,
      },
      'zh-HK': {
        translation: zhHkTranslation,
      },
    },
    lng: 'zh-HK', // Default language (Traditional HK)
    debug: true, // Enable debug to see why translation is failing
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh-CN', 'zh-HK'],
    load: 'currentOnly',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
